import React, { useState } from "react";
import {
  Box,
  FormControlLabel,
  IconButton,
  Slider,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import Title from "../title";
import CloseIcon from "@mui/icons-material/Close";
import Files from "react-files";
import { useMediaQuery } from "react-responsive";

const SliderSelect = ({
  formData,
  setFormData,
  uploadOption,
  setUploadOption,
}) => {
  const isPortable = useMediaQuery({ query: "(max-width:1200px)" });
  const [screenshotCount, setScreenshotCount] = useState(1);
  const [urls, setUrls] = useState([""]);
  const [images, setImages] = useState([]);

  const handleSliderChange = (event, newValue) => {
    setScreenshotCount(newValue);

    // Update URLs array based on selected count
    if (newValue > urls.length) {
      setUrls((prev) => [...prev, ""]);
    } else {
      setUrls((prev) => prev.slice(0, newValue));
    }

    // Update formData with only the array of URLs
    setFormData((prev) => ({
      ...prev,
      screenshot_urls: urls.slice(0, newValue),
    }));
  };

  const handleUrlChange = (index, value) => {
    const updatedUrls = [...urls];
    updatedUrls[index] = value;
    setUrls(updatedUrls);
    setFormData((prev) => ({
      ...prev,
      screenshot_urls: updatedUrls, // Ensure this is an array
    }));
  };

  const handleFileChange = (files) => {
    if (files && files.length > 0) {
      setImages(files);
      // Update formData with selected images
      setFormData((prev) => ({ ...prev, photos: files }));
    }
  };

  const toggleUploadOption = () => {
    setUploadOption((prev) =>
      prev === "uploadImages" ? "enterUrls" : "uploadImages"
    );
    // Reset states when toggling
    if (uploadOption === "enterUrls") {
      setUrls([""]); // Reset URLs
      setScreenshotCount(1); // Reset count
      setFormData((prev) => ({
        ...prev,
        screenshot_urls: [], // Reset screenshot_urls field in formData
      }));
    } else {
      setImages([]); // Reset images
      setFormData((prev) => ({
        ...prev,
        photos: [], // Reset photos field in formData
      }));
    }
  };

  return (
    <div className="slider-container">
      <Title title="Screenshots Options" />
      <div className="switcher">
        <FormControlLabel
          control={
            <Switch
              checked={uploadOption === "enterUrls"}
              onChange={toggleUploadOption}
              name="uploadOptionSwitch"
            />
          }
          label={
            uploadOption === "uploadImages"
              ? "Switch to Enter URLs"
              : "Switch to Upload Images"
          }
        />
      </div>
      <div className="slider-ways-container">
        {((isPortable && uploadOption === "uploadImages") || !isPortable) && (
          <Box
            sx={{
              width: "100%",
              opacity: uploadOption === "enterUrls" ? 0.5 : 1,
              pointerEvents: uploadOption === "enterUrls" ? "none" : "auto",
            }}
          >
            <div
              className="custom-slider"
              style={{
                cursor:
                  uploadOption === "enterUrls" ? "not-allowed" : "pointer",
              }}
            >
              <Files
                onChange={handleFileChange}
                onError={(error) => console.error("File upload error:", error)}
                accepts={["image/*"]}
                clickable
                multiple={true}
                maxFileSize={10485760} // Limit to 10MB per file
                disabled={uploadOption === "enterUrls"}
                className="files"
              />
              {images.length > 0 ? (
                <div className="selected-slider-container">
                  {Array.from(images).map((file, index) => (
                    <div key={index} className="selected-image">
                      <img
                        src={URL.createObjectURL(file)}
                        alt={`Uploaded ${index}`}
                        className={"selected-logo-img"}
                      />
                      <IconButton
                        onClick={() => {
                          const newImages = images.filter(
                            (_, i) => i !== index
                          );
                          setImages(newImages);
                          setFormData((prev) => ({
                            ...prev,
                            photos: newImages,
                          }));
                        }}
                        className="selected-image-remove"
                      >
                        <CloseIcon />
                      </IconButton>
                    </div>
                  ))}
                </div>
              ) : (
                <Typography variant="body2" color="textSecondary">
                  Click to upload images
                </Typography>
              )}
            </div>
          </Box>
        )}
        {((isPortable && uploadOption === "enterUrls") || !isPortable) && (
          <div
            style={{
              opacity: uploadOption === "uploadImages" ? 0.5 : 1,
              pointerEvents: uploadOption === "uploadImages" ? "none" : "auto",
              cursor: uploadOption === "uploadImages" ? "not-allowed" : "auto",
            }}
            className="logo"
          >
            <div className="main-title">
              <Title title="Number of Screenshots" />
            </div>
            <Slider
              value={screenshotCount}
              onChange={handleSliderChange}
              min={1}
              max={4}
              step={1}
              valueLabelDisplay="auto"
              sx={{ width: "300px", marginBottom: "20px", marginTop: "30px" }}
            />
            <Box className="main-logo-container">
              <Box className="main-styles-container">
                {Array.from({ length: screenshotCount }).map((_, index) => (
                  <TextField
                    key={index}
                    fullWidth
                    variant="outlined"
                    placeholder={`Enter URL for Screenshot ${index + 1}`}
                    value={urls[index]}
                    onChange={(e) => handleUrlChange(index, e.target.value)}
                    sx={{ marginBottom: "16px" }}
                  />
                ))}
              </Box>
            </Box>
          </div>
        )}
      </div>
    </div>
  );
};

export default SliderSelect;
